/**
 * Helper pour les logs conditionnels en production
 * Réduit les logs en production pour améliorer les performances
 */
export const logger = {
  log: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  },
  warn: (...args) => {
    // Toujours afficher les warnings
    console.warn(...args);
  },
  error: (...args) => {
    // Toujours afficher les erreurs
    console.error(...args);
  },
};

